import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { useTour } from '@reactour/tour';
import { DEMO_EVENT } from 'utils/constants';

import c from '../utils/constants';

export default function useGetEvent(id: string) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;
  const { isOpen } = useTour();

  return useQuery({
    queryKey: [c.EVENTS, id],
    queryFn: async () => {
      const api = new Api(args);

      if (isOpen) {
        return DEMO_EVENT;
      }

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/calendar/events/${id}`,
            params: {
              include: ['accountUser', 'tag'],
            },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/calendar/events/${id}`,
            params: {
              include: ['accountUser', 'tag'],
            },
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
